import createAsyncActionType from '../../../utilities/createAsyncActionType';

export const RUN_DB_CLIENTS_SCORING = createAsyncActionType('RUN_DB_CLIENTS_SCORING');


// WEBPACK FOOTER //
// ./src/features/score-card/types/runDbClientsScoringTypes.js